import { cva } from "class-variance-authority"
import PropTypes from "prop-types"
import { forwardRef, memo } from "react"

import { cn } from "styles/utils"

const textareaVariants = cva(
  "disabled:text-grey-30 outline-hidden w-full max-w-full",
  {
    defaultVariants: {
      variant: "default",
    },
    variants: {
      variant: {
        checkout:
          "border-grey-30 text-16 focus:ring-3 focus:ring-selected placeholder:text-grey-50 rounded-md border px-12 py-8",
        default:
          "border-grey-10 text-14 leading-16 placeholder:text-grey-35 border p-10 text-black focus:border focus:border-black",
      },
    },
  }
)

const Textarea = forwardRef(
  (
    {
      className,
      containerClassName,
      error,
      label,
      labelClassName,
      variant,
      ...props
    },
    ref
  ) => (
    <div className={cn(containerClassName)}>
      {label && (
        <label
          className={cn("text-14 leading-20 mb-6 font-medium", labelClassName)}
          htmlFor={props.id || props.name}
        >
          {label}
        </label>
      )}
      <textarea
        className={cn(textareaVariants({ className, variant }))}
        ref={ref}
        {...props}
      />
      {error && (
        <p className="text-error text-12 mt-8">{error.message || error}</p>
      )}
    </div>
  )
)

Textarea.propTypes = {
  className: PropTypes.string,
  containerClassName: PropTypes.string,
  error: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
  id: PropTypes.string,
  label: PropTypes.string,
  labelClassName: PropTypes.string,
  name: PropTypes.string,
  variant: PropTypes.oneOf(["checkout", "default"]),
}

Textarea.displayName = "Textarea"

export default memo(Textarea)
